import React from 'react';
import ChevronRightGrey from "../../../../icons/chevron-right-grey.svg";

interface MenuItemProps {
  label: string;
  hasSubmenu?: boolean;
  isNew?: boolean;
  sticker?: string;
  onClick?: () => void;
  className?: string;
  showChevron?: boolean;
  children?: React.ReactNode;
}

export const MenuItem: React.FC<MenuItemProps> = ({
  label,
  hasSubmenu = false,
  isNew = false,
  sticker,
  onClick,
  className = "",
  showChevron = true,
  children
}) => {
  return (
    <button 
      className={`side-menu-item-btn ${className}`}
      onClick={onClick}
    >
      <div className="side-menu-submenu-item">
        <span className="side-menu-item-text">{label}</span>
        {isNew && sticker && <span className="side-menu-new-badge">{sticker}</span>}
        {children}
      </div>
      {showChevron && (
        <img src={ChevronRightGrey} alt="arrow" className="side-menu-item-arrow" />
      )}
    </button>
  );
};
